import React, { Children, useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { Box, Button, Divider, Grid } from "@mui/material";
import { StyledButton } from "../../../../../shared/components/buttons/custom-button";
import FormBuilder from "../../../../../shared/components/form-builder/form-builder";
import {
  BuyerSellerDetails,
  buyerSellerDetails,
  INonCertifiedTrader,
  mapBuyerSellerDetailsApiResponseToInitialValues,
  mapPayload,
} from "../../../tc-models/tc-req-dto/tc-buyer-seller-details.req_dto";
import { buyerSellerDetailsService } from "../../../tc-service/buyer-seller-details.service";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import useNotification from "../../../../../shared/hooks/useNotification";
import { useFormActions } from "../../../../../shared/hooks/form-builder.hooks";
import { useApi } from "../../../../../shared/hooks/useApi";
import { LoaderComponent } from "../../../../../shared/components/loaders/page-loader";
import {
  TC_CREATE_ROUTE_CONFIG,
  TCAppConfig,
} from "../../../../../shared/app-configs/tc-app-configs";
import { dtrackItService } from "../../../tc-service/dtrackit.service";
import { CustomButton } from "../../../../../shared/components/buttons/buttons";
import ModalPopup from "../../../../../shared/components/modals/custom-popup";
import RawMaterialInfo from "./non-certified-trader";
import { ITcProductRawMaterialInformation } from "../../../tc-models/tc-req-dto/tc-certified-product-details.req_dto";
import NonCertifiedTraderInfo from "./non-certified-trader";
import { useFormik } from "formik";
import { all } from "axios";
import { Utills } from "../../../../../shared/app-configs/utilit";
import { useTransactionCertificateStore } from "../../../../../store/transaction-certificates.store";
import { useRecentTEIds } from "../../../../../shared/hooks/useRecentTEIds";

interface SellerCertifiedProductsProps {
  onNextTab: () => Promise<void>;
}

const SellerCertifiedProducts: React.FC<SellerCertifiedProductsProps> = ({
  onNextTab,
}) => {
  const { notify } = useNotification();
  const { TE_ID, formtype } = useParams<string>();
  const hasCreateTc: boolean = formtype === "create-tc";
  const [countries, setCountries] = useState([]);
  const [states, setState] = useState([]);
  const [getBuyerStates, setBuyerStates] = useState([]);
  const [getSellerStates, setSellerStates] = useState([]);

  const [getBuyerName, setBuyerName] = useState("");
  const [getBuyingOnBehalfOfFlag, setBuyingOnBehalfOfFlag] = useState("Y");

  const { loading, executeGet, setLoadingState, executePost } = useApi();
  const { isRestrictPopUpSave, setCountryCodes, setStates, getTCStandardGOTS, getEditTCInfo, isAdmin } =
    useTransactionCertificateStore();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [visible, setVisible] = useState({
    sellerTEId: true,
    sellerName: true,
    buyerSeacrhTEId: true,
    disableBuyerTEId: false,
    disableBuyerTEName: false,
    buyerSearchName: true,
    buyerTEIdLabel: true,
    sellerTEIdLabel: true,
  });
  const [disable, setDisable] = useState({
    sellerCountry: true,
    sellerState: true,
    buyerCountry: true,
    buyerState: true,
    sellerPostCode: true,
    buyerPostCode: true,
    sellerTown: true,
    buyerTown: true,
    buyerAddress1: true,
    sellerAddress1: true,
  });
  const [isBuyerTeCertifiedVisbile, setBuyerTeCertifiedVisbile] =
    useState<boolean>(true);
  const [cachedBuyerDetails, setCachedBuyerDetails] = useState<any>(null);
  const hasSubmitTC: boolean = formtype === "submited-tc";
  const [initialValues, setInitialValues] =
    useState<BuyerSellerDetails>(buyerSellerDetails);
  const nonCertifiedTraderDatas: INonCertifiedTrader[] = [];

  const [stepData, setStepData] = useState({
    nonCertifiedTrader: nonCertifiedTraderDatas,
  });
  const navigate = useNavigate();
  const { getCurrentFormValues, updateField } = useFormActions(
    "buyer-seller-products"
  );
  const { recentTEIds, saveRecentlySelectedTEId } = useRecentTEIds();

  const setZustandInitialState = (initial?: any) => {
    const defalutState: any = initialValues;
    //set zustand state inital values
    Object.entries(initial ?? defalutState).forEach(([key, value]) => {
      updateField(key, value);
    });
  };

  const buyerSellerDetailsValidationSchema = Yup.object().shape({
    // Seller Details
    sellerLicenseNumber: Yup.string()
      .required("Seller Client No. is required")
      .max(40, "Maximum 40 Characters is allowed"), //-
    sellerCertifiedOrganizationName: Yup.string().when([], {
      is: () => getTCStandardGOTS,
      then: Yup.string().required(
        "Seller Certified Organization Name is required"
      ),
      otherwise: Yup.string().when("sellingOnBehalfOfFlag", {
        is: (val: any) => val === "Y",
        then: Yup.string().required(
          "Seller Certified Organization Name is required"
        ),
        otherwise: Yup.string().nullable(),
      }),
    }),
    sellerCountryOrArea: Yup.string().required(
      "Seller Country/Area is required"
    ),
    buyerLicenseNumber: Yup.string()
      .nullable()
      .when([], {
        is: () => getTCStandardGOTS,
        then: (schema) => schema.required("Buyer Client Number is required"),
        otherwise: (schema) => schema.nullable(),
      }),
    buyerCertifiedOrganizationName: Yup.string()
      .nullable()
      .when([], {
        is: () => getTCStandardGOTS,
        then: (schema) =>
          schema.required("Buyer Certified Organization Name is required")
            .test('not-invalid-value', 'A valid buyer\'s certified organization name is required. "n/a, N/A, NULL, null, Not available" are not accepted', 
              function(value) {
                if (!value) return false; // Required will handle this
                const trimmedValue = value.trim().toLowerCase();
                const invalidValues = ['n/a', 'n\\a', 'null', 'not available', 'na', 'nil'];
                const isInvalid = invalidValues.some(invalid => trimmedValue === invalid);
                return !isInvalid;
              }),
        otherwise: (schema) => 
          schema.when('buyingOnBehalfOfFlag', {
            is: 'Y',
            then: (schema) => 
              schema.required('A valid buyer\'s certified organization name is required.')
                .test('not-invalid-value', 'A valid buyer\'s certified organization name is required. "n/a, N/A, NULL, null, Not available" are not accepted', 
                  function(value) {
                    if (!value) return false;
                    const trimmedValue = value.trim().toLowerCase();
                    const invalidValues = ['n/a', 'n\\a', 'null', 'not available', 'na', 'nil'];
                    const isInvalid = invalidValues.some(invalid => trimmedValue === invalid);
                    return !isInvalid;
                  }),
            otherwise: (schema) => schema.nullable(),
          }),
      }),

    sellingOnBehalfOfFlag: Yup.string()
      .when([], {
        is: () => !getTCStandardGOTS,
        then: (schema) =>
          schema.required("Selling On Behalf Of Flag is required"),
      })
      .max(1, "Maximum 1 Character is allowed"),

    sellerName: Yup.string()
      .when([], {
        is: () => !getTCStandardGOTS,
        then: (schema) => schema.required("Seller Name is required"),
      })
      .max(255, "Maximum 255 Characters allowed"),

    sellerTEId: Yup.string()
      .when([], {
        is: () => !getTCStandardGOTS,
        then: (schema) => schema.required("Seller TE ID is required"),
      })
      .test(
        "sellerTEId-validation",
        "Custom Error: Seller TE ID must be different from Buyer TE ID",
        function (value) {
          const { buyerTEId } = this.parent;
          if (!value) return true;
          if (value === buyerTEId) {
            return this.createError({
              message: "Buyer TE ID must not be equal to Seller TE ID",
            });
          }
          return true;
        }
      ),

    sellerAddress1: Yup.string()
      .when([], {
        is: () => !getTCStandardGOTS,
        then: (schema) => schema.required("Seller Address Line 1 is required"),
      })
      .max(1000, "Maximum 1000 Characters is allowed"),

    sellerStateOrProvince: Yup.string().when([], {
      is: () => !getTCStandardGOTS,
      then: (schema) => schema.required("Seller State/Province required"),
    }),

    sellerSCNumber: Yup.string().when([], {
      is: () => !getTCStandardGOTS,
      then: (schema) => schema.required("Seller SC No. is required").min(6, "Minimum 6 characters are required"),
    }),

    buyingOnBehalfOfFlag: Yup.string().when([], {
      is: () => !getTCStandardGOTS,
      then: (schema) => schema.required("Buying On Behalf Of Flag is required"),
    }),

    buyerName: Yup.string()
      .when([], {
        is: () => !getTCStandardGOTS,
        then: (schema) => schema.required("Buyer Name is required")
          .test('not-invalid-value', 'A valid buyer\'s name is required. "n/a, na, n-a, not applicable, not available, null" are not accepted', 
            function(value) {
              if (!value) return false; // Required will handle this
              const trimmedValue = value.trim().toLowerCase();
              // Check if trimmed value is empty (whitespace-only)
              if (trimmedValue === '') {
                return this.createError({
                  message: 'A valid buyer\'s name is required'
                });
              }
              const invalidValues = ['n/a', 'na', 'n-a', 'not applicable', 'not available', 'null'];
              const isInvalid = invalidValues.some(invalid => trimmedValue === invalid);
              return !isInvalid;
            }),
      })
      .max(255, "Maximum 255 Characters is allowed"),

    buyerTEId: Yup.string()
      .nullable()
      .when('isBuyerTeCertified', {
        is: 'Y',
        then: (schema) => schema.required("Buyer TE-ID is required when Buyer has a TE-ID"),
        otherwise: (schema) => schema.nullable(),
      })
      .test(
        "buyerTEId-validation",
        "Custom Error: Buyer TE ID must be different from Seller TE ID",
        function (value) {
          const { sellerTEId } = this.parent;
          if (!value) return true;
          if (value === sellerTEId) {
            return this.createError({
              message: "Seller TE ID must not be equal to Buyer TE ID",
            });
          }
          return true;
        }
      ),

    buyerAddress1: Yup.string()
      .when([], {
        is: () => !getTCStandardGOTS,
        then: (schema) => schema.required("Buyer Address Line 1 is required").min(6, "Minimum 6 characters are required"),
      })
      .max(1000, "Maximum 1000 Characters is allowed"),

    buyerStateOrProvince: Yup.string().when([], {
      is: () => !getTCStandardGOTS,
      then: (schema) => schema.required("Buyer State/Province is required"),
    }),

    buyerCountryOrArea: Yup.string().when([], {
      is: () => !getTCStandardGOTS,
      then: (schema) => schema.required("Buyer Country or Area is required"),
    }),

    nonCertifiedTrader: Yup.array(),
    buyerAddress2: Yup.string().nullable(), // Optional field
    buyerAddress3: Yup.string().nullable(), // Optional field
    buyerPostcode: Yup.string().nullable(),
    buyerTown: Yup.string().nullable(),
    isBuyerTeCertified: Yup.string(),
    sellerNonCertifiedTraderName: Yup.string().nullable(), // Optional field
    SellerNonCertifiedTraderTEId: Yup.string().nullable(), // Optional field
    sellerPostcode: Yup.string().nullable(),
    sellerTown: Yup.string().nullable(),
  });

  useEffect(() => {
    if (getTCStandardGOTS) {
      // alert(getTCStandardGOTS)
      setDisable((prev) => ({
        ...prev,
        sellerCountry: false,
        sellerState: false,
        buyerCountry: false,
        buyerState: false,
        sellerPostCode: false,
        buyerPostCode: false,
      }));
    }
    const fetchTcBaseDetails = async () => {
      try {
        const response: any = await executeGet(
          TCAppConfig.GET_TC_BUYERSSELLERS_DETAILS,
          { tcId: TE_ID }
        );
        if (response.data) {
          const data: any = mapBuyerSellerDetailsApiResponseToInitialValues(
            response.data
          );
          if (data.nonCertifiedTrader.length > 0) {
            setStepData({ nonCertifiedTrader: data.nonCertifiedTrader });
          }
          console.log("data", data);
          // setTimeout(() => {
          if (data?.sellerTEId && data?.sellerTEId !== "") {
            setVisible((prev) => ({
              ...prev,
              sellerTEIdLabel: false,
            }));
          }
          if(data?.buyerName){
            setBuyerName(data?.buyerName);
          }
          if (data?.buyerTEId && data?.buyerTEId !== "") {
            setVisible((prev) => ({
              ...prev,
              buyerTEIdLabel: false,
            }));
          }
          if (data?.buyerCountryOrArea) {
            // alert(initialValues?.buyerCountryOrArea)
            let countryCode = JSON.stringify(
              `[${[data?.buyerCountryOrArea].map((item) => `'${item}'`)}]`
            ).replace(/^"|"$/g, "");
            await getState(countryCode, true);
          }
          if (data?.sellerCountryOrArea) {
            // alert(initialValues?.sellerCountryOrArea)
            let countryCode = JSON.stringify(
              `[${[data?.sellerCountryOrArea].map((item) => `'${item}'`)}]`
            ).replace(/^"|"$/g, "");
            await getState(countryCode, false);
          }

          if (data?.buyerPostcode) {
            setDisable((prev) => ({
              ...prev,
              buyerPostCode: true,
            }));
          } else {
            setDisable((prev) => ({
              ...prev,
              buyerPostCode: false,
            }));
          }

          if (data?.sellerPostCode) {
            setDisable((prev) => ({
              ...prev,
              sellerPostCode: true,
            }));
          } else {
            setDisable((prev) => ({
              ...prev,
              sellerPostCode: false,
            }));
          }

          if (data?.sellerTown) {
            setDisable((prev) => ({
              ...prev,
              sellerTown: true,
            }));
          } else {
            setDisable((prev) => ({
              ...prev,
              sellerTown: false,
            }));
          }

          if (data?.buyerTown) {
            setDisable((prev) => ({
              ...prev,
              buyerTown: true,
            }));
          } else {
            setDisable((prev) => ({
              ...prev,
              buyerTown: false,
            }));
          }

          // Initialize visibility states based on isBuyerTeCertified
          if (data?.isBuyerTeCertified === "Y") {
            setBuyerTeCertifiedVisbile(true);
            setVisible((prev) => ({
              ...prev,
              buyerSearchName: true,
              buyerSeacrhTEId: true,
              disableBuyerTEId: true,
              disableBuyerTEName: true,
            }));
            setDisable((prev) => ({
              ...prev,
              buyerCountry: true,
              buyerState: true,
              buyerPostCode: true,
            }));
          } else if (data?.isBuyerTeCertified === "N") {
            setBuyerTeCertifiedVisbile(false);
            setVisible((prev) => ({
              ...prev,
              buyerSeacrhTEId: false,
              buyerSearchName: false,
              disableBuyerTEId: false,
              disableBuyerTEName: false,
            }));
            setDisable((prev) => ({
              ...prev,
              buyerCountry: false,
              buyerState: false,
              buyerPostCode: false,
            }));
          }

          setInitialValues(data);
          setZustandInitialState(data);
          // }, 5000); // Delay execution by 500 milliseconds (adjust as needed)
        }
      } catch (err) {
        console.error("Failed to fetch TC Base Details:", err);
      }
    };
    const getCountry = async () => {
      try {
        const result: any = await dtrackItService.getCountry();
        // Utills.cl(`getCountry result ${JSON.stringify(result)}`);
        const countries = result.data.map((t: any) => ({
          value: t.code_1,
          label: t.description_1 + " (" + t.code_1 + ")",
        }));
        // Utills.cl(`countries ${countries}`);
        setCountries(countries);
        setCountryCodes(countries);
        // Utills.cl(`getCountry ${countries}`)
      } catch (err) {
        Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
      }
    };
    getCountry();
    if (TE_ID) {
      fetchTcBaseDetails();
    } else {
      setZustandInitialState();
    }
    // //alert(typeof getTCStandard)
  }, []);

  const getState = async (buyersCountryOrArea: any, isBuyer: boolean) => {
    try {
      // alert(`buyersCountryOrArea ${buyersCountryOrArea}, isBuyer ${isBuyer}`)
      const result: any = await dtrackItService.getStateBasedonCountry(
        buyersCountryOrArea
      );
      const states = result.data.map((t: any) => ({
        value: t.code_1,
        label: `${t.description_1} (${t.code_1})`,
      }));
      if (isBuyer) {
        setBuyerStates(states);
      } else {
        setSellerStates(states);
      }
      setState(states);
      setStates(states);
    } catch (err) {
      Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
    }
  };

  // Simulate API call for fetching options
  const fetchTEDetallsFromAPI = async (
    value: string,
    offset: number,
    type: string,
    name?: string
  ): Promise<any[]> => {
    try {
      const queryParams: Record<string, any> = {
        query_param: type == "query" ? value : "",
        offset: offset,
        name: type == "name" ? value : "",
      };
      // Fetch TE Details using the getTEDetails function
      const response = await buyerSellerDetailsService.getTEDetails(
        queryParams
      );
      const data = response.data;
      Utills.cl(
        `fetchTEDetallsFromAPI details, query ${JSON.stringify(
          queryParams
        )} response data ${JSON.stringify(data)}`
      );

      return data;
    } catch (error) {
      console.error("Error fetching TE details:", error);
      throw error; // Re-throw error to handle it in the calling code
    }
  };

  // Handle selection change from SearchInput
  const handleSellerTEIdValueChange = (value: any) => {
    if (value) {
      // Save selected TE details to recent list
      saveRecentlySelectedTEId(value);
    }
    if (formRef.current.values.sellingOnBehalfOfFlag === "N") {
      formRef.current.setFieldValue(
        "sellerCertifiedOrganizationName",
        value == null ? "" : value.account_name
      );
    }
    const fields = [
      "sellerAddress1",
      "sellerTown",
      "sellerPostcode",
      "sellerStateOrProvince",
      "sellerCountryOrArea",
      "sellerName",
      "sellerTEId",
    ];
    if (value == null) {
      fields.forEach((field) => {
        formRef.current.setFieldValue(field, "");
      });
      setDisable((prev) => ({
        ...prev,
        sellerState: true,
        sellerCountry: true,
        sellerPostCode: true,
        sellerTown: true,
      }));
      setVisible((prev) => ({
        ...prev,
        sellerName: true,
        sellerTEIdLabel: true,
      }));
    } else {
      formRef.current.setFieldValue("sellerName", value.account_name);
      formRef.current.setFieldValue("sellerTEId", value.TE_ID);
      // formRef.current.setFieldValue("sellerAddress1", value.street);
      // formRef.current.setFieldValue("sellerTown", value.city);
      // formRef.current.setFieldValue("sellerPostcode", value.postal_code);
      if (
        value.country != null &&
        value.country != "" &&
        value.country != undefined
      ) {
        let countryCode = JSON.stringify(
          `[${[value.country].map((item) => `'${item}'`)}]`
        ).replace(/^"|"$/g, "");
        getState(countryCode, false);
      }

      if (value.street == null) {
        setDisable((prev) => ({
          ...prev,
          sellerAddress1: false,
        }));
        formRef.current.setFieldValue("sellerAddress1", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerAddress1: true,
        }));
        formRef.current.setFieldValue("sellerAddress1", value.street);
      }

      if (value.city == null) {
        setDisable((prev) => ({
          ...prev,
          sellerTown: false,
        }));
        formRef.current.setFieldValue("sellerTown", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerTown: true,
        }));
        formRef.current.setFieldValue("sellerTown", value.city);
      }

      if (value.postal_code == null) {
        setDisable((prev) => ({
          ...prev,
          sellerPostCode: false,
        }));
        formRef.current.setFieldValue("sellerPostcode", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerPostCode: true,
        }));
        formRef.current.setFieldValue("sellerPostcode", value.postal_code);
      }
      if (value.country == null) {
        setDisable((prev) => ({
          ...prev,
          sellerCountry: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerCountry: true,
        }));
        formRef.current.setFieldValue("sellerCountryOrArea", value.country);
      }

      if (value.state == null) {
        setDisable((prev) => ({
          ...prev,
          sellerState: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerState: true,
        }));
        formRef.current.setFieldValue("sellerStateOrProvince", value.state);
      }
      setVisible((prev) => ({
        ...prev,
        sellerName: false,
        sellerTEIdLabel: false,
      }));
    }
  };

  const handleSellerNamedValueChange = (value: any) => {
    // //alert(`form ${JSON.stringify(formRef.current.values)}`)
    if (formRef.current.values.sellingOnBehalfOfFlag === "N") {
      formRef.current.setFieldValue(
        "sellerCertifiedOrganizationName",
        value == null ? "" : value.account_name
      );
    }
    const fields = [
      "sellerAddress1",
      "sellerAddress2",
      "sellerAddress3",
      "sellerTown",
      "sellerPostcode",
      "sellerStateOrProvince",
      "sellerCountryOrArea",
      "sellerLicenseNumber",
      "sellerNonCertifiedTraderName",
      "sellerName",
      "sellerTEId",
    ];
    if (value == null) {
      fields.forEach((field) => {
        formRef.current.setFieldValue(field, "");
      });
      setDisable((prev) => ({
        ...prev,
        sellerState: true,
        sellerCountry: true,
        sellerPostCode: true,
        sellerTown: true,
      }));
      setVisible((prev) => ({
        ...prev,
        sellerTEId: true,
      }));
    } else {
      formRef.current.setFieldValue("sellerName", value.account_name);
      formRef.current.setFieldValue("sellerTEId", value.TE_ID);
      // formRef.current.setFieldValue("sellerAddress1", value.street);
      // formRef.current.setFieldValue("sellerTown", value.city);
      // formRef.current.setFieldValue("sellerPostcode", value.postal_code);
      if (
        value.country != null &&
        value.country != "" &&
        value.country != undefined
      ) {
        let countryCode = JSON.stringify(
          `[${[value.country].map((item) => `'${item}'`)}]`
        ).replace(/^"|"$/g, "");
        getState(countryCode, false);
      }

      if (value.street == null) {
        setDisable((prev) => ({
          ...prev,
          sellerAddress1: false,
        }));
        formRef.current.setFieldValue("sellerAddress1", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerAddress1: true,
        }));
        formRef.current.setFieldValue("sellerAddress1", value.street);
      }

      if (value.city == null) {
        setDisable((prev) => ({
          ...prev,
          sellerTown: false,
        }));
        formRef.current.setFieldValue("sellerTown", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerTown: true,
        }));
        formRef.current.setFieldValue("sellerTown", value.city);
      }
      if (value.city == null) {
        setDisable((prev) => ({
          ...prev,
          sellerTown: false,
        }));
        formRef.current.setFieldValue("sellerTown", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerTown: true,
        }));
        formRef.current.setFieldValue("sellerTown", value.city);
      }

      if (value.postal_code == null) {
        setDisable((prev) => ({
          ...prev,
          sellerPostCode: false,
        }));
        formRef.current.setFieldValue("sellerPostcode", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerPostCode: true,
        }));
        formRef.current.setFieldValue("sellerPostcode", value.postal_code);
      }
      if (value.country == null) {
        setDisable((prev) => ({
          ...prev,
          sellerCountry: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerCountry: true,
        }));
        formRef.current.setFieldValue("sellerCountryOrArea", value.country);
      }

      if (value.state == null) {
        setDisable((prev) => ({
          ...prev,
          sellerState: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          sellerState: true,
        }));
        formRef.current.setFieldValue("sellerStateOrProvince", value.state);
      }
      setVisible((prev) => ({
        ...prev,
        sellerTEId: false,
      }));
    }
  };

  const handleBuyerTEIdValueChange = async (value: any) => {
    const fields = [
      "buyerAddress1",
      "buyerTown",
      "buyerPostcode",
      "buyerStateOrProvince",
      "buyerCountryOrArea",
      "buyerName",
      "buyerTEId",
    ];
    if (value == null) {
      setBuyerName("");
      fields.forEach((field) => {
        formRef.current.setFieldValue(field, "");
      });
      setVisible((prev) => ({
        ...prev,
        buyerSearchName: true,
      }));
      setVisible((prev) => ({
        ...prev,
        disableBuyerTEName: false,
        buyerTEIdLabel: true,
      }));
      setDisable((prev) => ({
        ...prev,
        buyerCountry: true,
        buyerState: true,
        buyerPostCode: true,
        buyerTown: true,
      }));
    } else {
      // Save selected TE details to recent list
      saveRecentlySelectedTEId(value);
      formRef.current.setFieldValue("buyerName", value.account_name);
      formRef.current.setFieldValue("buyerTEId", value.TE_ID);
      // formRef.current.setFieldValue("buyerAddress1", value.street);
      // formRef.current.setFieldValue("buyerPostcode", value.postal_code || "");
      setBuyerName(value.account_name);
      
      setVisible((prev) => ({
        ...prev,
        buyerSearchName: false,
        disableBuyerTEName: true,
        buyerTEIdLabel: false,
      }));
      if (getBuyingOnBehalfOfFlag == "N") {
        formRef.current.setFieldValue(
          "buyerCertifiedOrganizationName",
          value.account_name
        );
      }
      if (
        value.country != null &&
        value.country != "" &&
        value.country != undefined
      ) {
        let countryCode = JSON.stringify(
          `[${[value.country].map((item) => `'${item}'`)}]`
        ).replace(/^"|"$/g, "");
        await getState(countryCode, true);
      }
      if (value.street == null) {
        setDisable((prev) => ({
          ...prev,
          buyerAddress1: false,
        }));
        formRef.current.setFieldValue("buyerAddress1", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerAddress1: true,
        }));
        formRef.current.setFieldValue("buyerAddress1", value.street || "");
      }

      if (value.city == null) {
        setDisable((prev) => ({
          ...prev,
          buyerTown: false,
        }));
        formRef.current.setFieldValue("buyerTown", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerTown: true,
        }));
        formRef.current.setFieldValue("buyerTown", value.city || "");
      }
      if (value.city == null) {
        setDisable((prev) => ({
          ...prev,
          buyerTown: false,
        }));
        formRef.current.setFieldValue("buyerTown", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerTown: true,
        }));
        formRef.current.setFieldValue("buyerTown", value.city);
      }

      if (value.postal_code == null) {
        // alert("buyer postal code null")
        setDisable((prev) => ({
          ...prev,
          buyerPostCode: false,
        }));
        formRef.current.setFieldValue("buyerPostcode", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerPostCode: true,
        }));
        formRef.current.setFieldValue("buyerPostcode", value.postal_code);
      }

      if (value.country == null) {
        setDisable((prev) => ({
          ...prev,
          buyerCountry: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerCountry: true,
        }));
        formRef.current.setFieldValue("buyerCountryOrArea", value.country);
      }
      if (value.state == null) {
        setDisable((prev) => ({
          ...prev,
          buyerState: false,
        }));
        // //alert(disable.buyerState)
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerState: true,
        }));
        formRef.current.setFieldValue("buyerStateOrProvince", value.state);
      }
    }
  };

  const handleBuyerNameValueChange = (value: any) => {
    const fields = [
      "buyerAddress1",
      "buyerTown",
      "buyerPostcode",
      "buyerStateOrProvince",
      "buyerCountryOrArea",
      "buyerName",
      "buyerTEId",
    ];
    if (value == null) {
      setBuyerName("");
      if (getBuyingOnBehalfOfFlag == "N") {
        formRef.current.setFieldValue(
          "buyerCertifiedOrganizationName",
          ""
        );
      }
      fields.forEach((field) => {
        formRef.current.setFieldValue(field, "");
      });
      setVisible((prev) => ({
        ...prev,
        buyerSeacrhTEId: true,
        disableBuyerTEId: false,
        buyerTEIdLabel:true
      }));
      setDisable((prev) => ({
        ...prev,
        buyerCountry: true,
        buyerState: true,
        buyerPostCode: true,
        buyerTown: true,
      }));
    } else {
      formRef.current.setFieldValue("buyerName", value.account_name);
      formRef.current.setFieldValue("buyerTEId", value.TE_ID);
      formRef.current.setFieldValue("buyerAddress1", value.street);
      // formRef.current.setFieldValue("buyerTown", value.city || "");
      // formRef.current.setFieldValue("buyerPostcode", value.postal_code || "");
      setBuyerName(value?.account_name);
      if (getBuyingOnBehalfOfFlag == "N") {
        formRef.current.setFieldValue(
          "buyerCertifiedOrganizationName",
          value.account_name
        );
      }
      if (
        value.country != null &&
        value.country != "" &&
        value.country != undefined
      ) {
        let countryCode = JSON.stringify(
          `[${[value.country].map((item) => `'${item}'`)}]`
        ).replace(/^"|"$/g, "");
        getState(countryCode, true);
      }

      if (value.city == null) {
        setDisable((prev) => ({
          ...prev,
          buyerTown: false,
        }));
        formRef.current.setFieldValue("buyerTown", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerTown: true,
        }));
        formRef.current.setFieldValue("buyerTown", value.city);
      }

      if (value.postal_code == null) {
        setDisable((prev) => ({
          ...prev,
          buyerPostCode: false,
        }));
        formRef.current.setFieldValue("buyerPostcode", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerPostCode: true,
        }));
        formRef.current.setFieldValue("buyerPostcode", value.postal_code);
      }

      if (value.city == null) {
        setDisable((prev) => ({
          ...prev,
          buyerTown: false,
        }));
        formRef.current.setFieldValue("buyerTown", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerTown: true,
        }));
        formRef.current.setFieldValue("buyerTown", value.city || "");
      }

      if (value.country == null) {
        setDisable((prev) => ({
          ...prev,
          buyerCountry: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerCountry: true,
        }));
        formRef.current.setFieldValue("buyerCountryOrArea", value.country);
      }

      if (value.state == null) {
        setDisable((prev) => ({
          ...prev,
          buyerState: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          buyerState: true,
        }));
        formRef.current.setFieldValue("buyerStateOrProvince", value.state);
      }
      setVisible((prev) => ({
        ...prev,
        buyerSeacrhTEId: false,
      }));
      setVisible((prev) => ({
        ...prev,
        disableBuyerTEId: true,
        buyerTEIdLabel:false
      }));
    }
  };

  const handleDataUpdate = (stepKey: string, updatedData: any) => {
    setStepData((prev) => ({
      ...prev,
      [stepKey]: updatedData,
    }));
  };
  // const testFOrmCOnfig = {
  //   pageName: "buyer-seller-products",
  //   initialValues,
  //   validationSchema: buyerSellerDetailsValidationSchema,
  //   sections: [
  //     {
  //       title: "Seller Details",
  //       fields: [
  //         {
  //           label: "testlink",
  //           name: "sellerTEId",
  //           type: "toggle",
  //           gridSize: { xs: 12, md: 4 },
  //           required: true,
  //           props: {
  //            children: <NavLink to="/test">Test</NavLink>
  //           },
  //         }
  //       ]
  //     }
  //   ],
  //   handleSubmit: async (values: any) => {
  //     try {

  //     } catch (error) {
  //       setLoadingState(false)
  //       console.error("Error saving Buyer & Seller Details:", error);
  //     }
  //   },
  // }
  const handleDialogOpen = () => {
    setDialogOpen(true);
    const zustandData = getCurrentFormValues();
    const nonCertifiedTrader =
      zustandData?.nonCertifiedTrader?.length > 0
        ? zustandData?.nonCertifiedTrader
        : [];
    setStepData({ nonCertifiedTrader: nonCertifiedTrader });
  };
  const formConfig = {
    pageName: "buyer-seller-products",
    initialValues,
    readOnly: hasSubmitTC,
    validationSchema: buyerSellerDetailsValidationSchema,
    sections: [
      {
        title: "Seller Details",
        fields: [
          {
            label: "Seller TE-ID",
            name: "sellerTEId",
            type: "search",
            gridSize: { xs: 12, md: 4 },
            required: getTCStandardGOTS ? false : true,
            disabled: (getEditTCInfo?.tcMetadataStatus === "Amending" ||
              (getEditTCInfo?.tcId === TE_ID && getEditTCInfo?.isParentStatus)) ? true : false,
            value: initialValues.sellerTEId,
            visible: (value: any) => !!(visible.sellerTEId && !(getEditTCInfo?.tcMetadataStatus === "Amending" || (getEditTCInfo?.tcId === TE_ID && getEditTCInfo?.isParentStatus))),
            props: {
              placeholder: "Search Seller TE-ID",
              variant: "outlined",
              restrictInputFormat: visible.sellerTEIdLabel,
              param: "SellerTEId",
              onChange: handleSellerTEIdValueChange,
              displayKey: "TE_ID",
              // Show recently selected TE IDs when the field is focused and empty
              fetchOnEmptyFocus: true,
              onSearch: (query: string, offset: number) => {
                // If query is empty, return recent TE IDs (if any)
                if (!query || query.trim() === "") {
                  return Promise.resolve(
                    recentTEIds.length > 0 ? recentTEIds : []
                  );
                }
                const response = fetchTEDetallsFromAPI(query, offset, "query");
                return response;
              },
              fullWidth: true,
            },
          },
          {
            label: "Seller TE-ID",
            name: "sellerTEId",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: getTCStandardGOTS ? false : true,
            // value: 'initialValues.sellerAddress1',
            disabled: true,
            visible: (value: any) => !!(!visible.sellerTEId || (getEditTCInfo?.tcMetadataStatus === "Amending" || getEditTCInfo?.tcId === TE_ID && getEditTCInfo?.isParentStatus)),
            props: {
              placeholder: "Enter Seller Name",
              fullWidth: true,
            },
          },
          {
            label: "Seller Name",
            name: "sellerName",
            type: "search",
            gridSize: { xs: 12, md: 4 },
            required: getTCStandardGOTS ? false : true,
            value: initialValues.sellerName,
            visible: (value: any) => !!visible.sellerName,
            // events: {
            //   onUpdate(val: any, allVal: any, setFieldVal: any) {
            //     //alert(allVal)
            //     if (allVal?.sellingOnBehalfOfFlag === 'N') {
            //       setFieldVal("sellerCertifiedOrganizationName", val === null ? "" : val)
            //     }
            //   }
            // },
            // disabled: (values: any) => { Utills.cl(`sellerName log ${JSON.stringify(values)}`); return false; },
            props: {
              placeholder: "Search Seller Name",
              variant: "outlined",
              onChange: handleSellerNamedValueChange,
              displayKey: "account_name",
              onSearch: (query: string, offset: number) => {
                Utills.cl(
                  `fetchTEDetallsFromAPI query ${query} offset ${offset}`
                );
                const response = fetchTEDetallsFromAPI(query, offset, "name");
                return response;
              },
              fullWidth: true,
            },
          },
          {
            label: "Seller Name",
            name: "sellerName",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: getTCStandardGOTS ? false : true,
            // value: 'initialValues.sellerAddress1',
            disabled: true,
            visible: (value: any) => !!!visible.sellerName,
            props: {
              placeholder: "Enter Seller Name",
              fullWidth: true,
            },
          },
          {
            label: "Seller Address",
            name: "sellerAddress1",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: getTCStandardGOTS ? false : true,
            // value: 'initialValues.sellerAddress1',
            disabled: disable.sellerAddress1,
            props: {
              placeholder: "Enter Seller Address",
              fullWidth: true,
            },
          },
          // {
          //   label: "Seller Address 2",
          //   name: "sellerAddress2",
          //   type: "text",
          //   gridSize: { xs: 12, md: 4 },
          //   required: false,
          //   value: initialValues.sellerAddress2,
          //   disabled: true,
          //   props: {
          //     placeholder: "Enter Seller Address 2",
          //     fullWidth: true,
          //   },
          // },
          // {
          //   label: "Seller Address 3",
          //   name: "sellerAddress3",
          //   type: "text",
          //   gridSize: { xs: 12, md: 4 },
          //   required: false,
          //   value: initialValues.sellerAddress3,
          //   disabled: true,
          //   props: {
          //     placeholder: "Enter Seller Address 3",
          //     fullWidth: true,
          //   },
          // },
          {
            label: "Town",
            name: "sellerTown",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            value: initialValues.sellerTown,
            disabled: disable.sellerTown,
            props: {
              placeholder: "Enter town",
              fullWidth: true,
            },
          },
          {
            label: "Postcode",
            name: "sellerPostcode",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            value: initialValues.sellerPostcode,
            disabled: (values: any) => {
              // If in amending/editing mode and postcode is empty, enable it for user input
              if ((getEditTCInfo?.tcMetadataStatus === "Amending" || 
                (getEditTCInfo?.tcId === TE_ID && getEditTCInfo?.isParentStatus)) && 
                !initialValues.sellerPostcode) {
                return false;
              }
              return disable.sellerPostCode;
            },
            props: {
              placeholder: "Enter postcode",
              fullWidth: true,
            },
          },
          {
            label: "Seller Country/Area",
            name: "sellerCountryOrArea",
            type: "select",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.sellerCountryOrArea,
            disabled: disable.sellerCountry,
            events: {
              onChange: (newValue: any, updatedValues: any) => {
                let countryCode = JSON.stringify(
                  `[${[newValue].map((item) => `'${item}'`)}]`
                ).replace(/^"|"$/g, "");
                getState(countryCode, false);
              },
            },
            props: {
              enableSearch: true,
              options: countries,
              placeholder: "Seller Country/Area",
              fullWidth: true,
            },
          },
          {
            label: "Seller State/Province",
            name: "sellerStateOrProvince",
            type: "select",
            gridSize: { xs: 12, md: 4 },
            required: getTCStandardGOTS ? false : true,
            value: initialValues.sellerStateOrProvince, // Set initial value here
            disabled: disable.sellerState,
            props: {
              options: getSellerStates,
              enableSearch: true,
              placeholder: "Seller State/Province",
              fullWidth: true,
            },
          },
          {
            label: "Seller SC No.",
            name: "sellerSCNumber",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: getTCStandardGOTS ? false : true,
            value: initialValues.sellerSCNumber,
            disabled: false,
            props: {
              placeholder: "Enter SC No.",
              fullWidth: true,
            },
          },
          // {
          //   label: "Seller SC No",
          //   name: "sellerSCNumber",
          //   type: "chips",
          //   gridSize: { xs: 10, md: 10 },
          //   required: true,
          //   value: initialValues.sellerSCNumber || [],
          //   props: {
          //     placeholder: "Select SC No",
          //   },
          // },
          {
            label: "",
            name: "nonCertifiedTrader",
            type: "component",
            gridSize: { xs: 2, md: 2, lg: 2 },
            required: getTCStandardGOTS ? false : true,
            children: (
              <>
                {" "}
                <CustomButton
                  sx={{
                    marginTop: "22px",
                    borderRadius: "30px", // Doubles the default border radius
                    padding: "1 3", // Adds padding for a balanced look
                    marginRight: 2, // Spacing between buttons
                    textTransform: "none", // Keeps button text in sentence case
                    backgroundColor: "#F0CD7F",
                    color: "#1C1C1C",
                    fontWeight: "400",
                    "&:hover": {
                      backgroundColor: "#E0B86F", // Change background color on hover
                      color: "#000000", // Change text color on hover
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
                    },
                  }}
                  onClick={handleDialogOpen}
                  variant="contained"
                  placement="center"
                  size="small"
                  errorMessage=""
                  label={
                    stepData?.nonCertifiedTrader.length === 0 ? (
                      <>
                        {hasSubmitTC ? "View " : "Add "}Non-Certified Trader
                        Info <span style={{ color: "#9E362C" }}></span> <br />
                      </>
                    ) : (
                      <>
                        {hasSubmitTC ? "View " : "Edit "} Non-Certified Trader
                        Info <span style={{ color: "#9E362C" }}></span>
                      </>
                    )
                  }
                ></CustomButton>
                <span
                  style={{
                    fontSize: "0.8em",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {stepData?.nonCertifiedTrader.length} Records Added
                </span>
              </>
            ),
            props: {},
          },
          {
            label: "Selling on Behalf of Flag",
            name: "sellingOnBehalfOfFlag",
            type: "radio",
            gridSize: { xs: 12, md: 4 },
            required: getTCStandardGOTS ? false : true,
            value: initialValues.sellingOnBehalfOfFlag,
            events: {
              onChange: (value: any) => {
                Utills.cl("buyer te certified", value);
                if (value === "Y") {
                  formRef.current.setFieldValue(
                    "sellerCertifiedOrganizationName",
                    ""
                  );
                } else {
                  if (formRef.current.values.sellerName === "") {
                    formRef.current.setFieldValue(
                      "sellerCertifiedOrganizationName",
                      ""
                    );
                  } else {
                    formRef.current.setFieldValue(
                      "sellerCertifiedOrganizationName",
                      formRef.current.values.sellerName
                    );
                  }
                }
              },
            },
            props: {
              options: [
                { value: "Y", label: "Yes" },
                { value: "N", label: "No" },
              ],
            },
          },
          {
            label: "Seller Certified Organization Name",
            name: "sellerCertifiedOrganizationName",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: (value: any) =>
              value.sellingOnBehalfOfFlag == "Y" || getTCStandardGOTS,
            value: initialValues.sellerCertifiedOrganizationName,
            disabled: (values: any) => {
              if (getTCStandardGOTS) {
                return false;
              }
              return values.sellingOnBehalfOfFlag === "N";
            },
            props: {
              placeholder: "Enter Certified Organization Name",
              variant: "outlined",
              fullWidth: true,
            },
          },
          {
            label: "Seller Client No.",
            name: "sellerLicenseNumber",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: true,
            value: initialValues.sellerLicenseNumber,
            disabled: false,
            props: {
              placeholder: "Enter Seller Client No.",
              variant: "outlined",
              fullWidth: true,
            },
          },
        ],
      },
      {
        title: "Buyer Details",
        fields: [
          {
            label: "Does the Buyer have a TE-ID?",
            name: "isBuyerTeCertified",
            type: "radio",
            gridSize: { xs: 12, md: 4 },
            required: false,
            value: initialValues.isBuyerTeCertified,
            events: {
              onChange: (value: any) => {
                Utills.cl("buyer te certified", value);
                if (value === "Y") {
                  // Restore cached buyer details if available
                  if (cachedBuyerDetails) {
                    formRef.current.setFieldValue("buyerTEId", cachedBuyerDetails.buyerTEId || "");
                    formRef.current.setFieldValue("buyerName", cachedBuyerDetails.buyerName || "");
                    formRef.current.setFieldValue("buyerAddress1", cachedBuyerDetails.buyerAddress1 || "");
                    formRef.current.setFieldValue("buyerAddress2", cachedBuyerDetails.buyerAddress2 || "");
                    formRef.current.setFieldValue("buyerAddress3", cachedBuyerDetails.buyerAddress3 || "");
                    formRef.current.setFieldValue("buyerTown", cachedBuyerDetails.buyerTown || "");
                    formRef.current.setFieldValue("buyerPostcode", cachedBuyerDetails.buyerPostcode || "");
                    formRef.current.setFieldValue("buyerCountryOrArea", cachedBuyerDetails.buyerCountryOrArea || "");
                    formRef.current.setFieldValue("buyerStateOrProvince", cachedBuyerDetails.buyerStateOrProvince || "");
                    formRef.current.setFieldValue("buyerLicenseNumber", cachedBuyerDetails.buyerLicenseNumber || "");
                  } else {
                    // Only clear dependent fields if no cache (initial state)
                    formRef.current.setFieldValue("buyerStateOrProvince", "");
                    formRef.current.setFieldValue("buyerCountryOrArea", "");
                    formRef.current.setFieldValue("buyerAddress1", "");
                    formRef.current.setFieldValue("buyerAddress2", "");
                    formRef.current.setFieldValue("buyerAddress3", "");
                    formRef.current.setFieldValue("buyerTown", "");
                    formRef.current.setFieldValue("buyerPostcode", "");
                    formRef.current.setFieldValue("buyerLicenseNumber", "");
                  }

                  setBuyerTeCertifiedVisbile(true);
                  setVisible((prev) => ({
                    ...prev,
                    buyerSearchName: true,
                    buyerSeacrhTEId: true,
                    disableBuyerTEId: true,
                    disableBuyerTEName: true,
                  }));
                  setDisable((prev) => ({
                    ...prev,
                    buyerCountry: true,
                    buyerState: true,
                    buyerPostCode: true,
                  }));
                } else {
                  // Cache current buyer details before clearing
                  const currentValues = formRef.current.values;
                  setCachedBuyerDetails({
                    buyerTEId: currentValues.buyerTEId,
                    buyerName: currentValues.buyerName,
                    buyerAddress1: currentValues.buyerAddress1,
                    buyerAddress2: currentValues.buyerAddress2,
                    buyerAddress3: currentValues.buyerAddress3,
                    buyerTown: currentValues.buyerTown,
                    buyerPostcode: currentValues.buyerPostcode,
                    buyerCountryOrArea: currentValues.buyerCountryOrArea,
                    buyerStateOrProvince: currentValues.buyerStateOrProvince,
                    buyerLicenseNumber: currentValues.buyerLicenseNumber,
                  });

                  // Clear all fields when switching to manual entry (No)
                  formRef.current.setFieldValue("buyerStateOrProvince", "");
                  formRef.current.setFieldValue("buyerCountryOrArea", "");
                  formRef.current.setFieldValue("buyerTEId", "");
                  formRef.current.setFieldValue("buyerName", "");
                  formRef.current.setFieldValue("buyerAddress1", "");
                  formRef.current.setFieldValue("buyerAddress2", "");
                  formRef.current.setFieldValue("buyerAddress3", "");
                  formRef.current.setFieldValue("buyerTown", "");
                  formRef.current.setFieldValue("buyerPostcode", "");
                  formRef.current.setFieldValue("buyerLicenseNumber", "");
                  setBuyerTeCertifiedVisbile(false);
                  setVisible((prev) => ({
                    ...prev,
                    buyerSeacrhTEId: false,
                    buyerSearchName: false,
                    disableBuyerTEId: false,
                    disableBuyerTEName: false,
                  }));
                  setDisable((prev) => ({
                    ...prev,
                    buyerCountry: false,
                    buyerState: false,
                    buyerPostCode: false,
                  }));
                }
              },
            },
            props: {
              options: [
                { value: "Y", label: "Yes" },
                { value: "N", label: "No" },
              ],
            },
          },
          {
            label: "Buyer TE-ID",
            name: "buyerTEId",
            type: "search",
            gridSize: { xs: 12, md: 4 },
            required: (values: any) => values?.isBuyerTeCertified === "Y",
            disabled: (values: any) => {
              // Disable search field only if in amending/parent status AND buyerTEId has initial value
              return (getEditTCInfo?.tcMetadataStatus === "Amending" ||
                (getEditTCInfo?.tcId === TE_ID && getEditTCInfo?.isParentStatus)) &&
              initialValues.buyerTEId ? true : false;
            },
            value: initialValues.buyerTEId,
            visible: (values: any) => !!(values?.isBuyerTeCertified === "Y" && !((getEditTCInfo?.tcMetadataStatus === "Amending" || (getEditTCInfo?.tcId === TE_ID && getEditTCInfo?.isParentStatus)) && initialValues.buyerTEId)),
            props: {
              placeholder: "Search Buyer TE-ID",
              variant: "outlined",
              displayKey: "TE_ID",
              restrictInputFormat: visible.buyerTEIdLabel,
              onChange: handleBuyerTEIdValueChange,
              // Show recently selected TE IDs when the field is focused and empty
              fetchOnEmptyFocus: true,
              onSearch: (query: string, offset: number) => {
                // If query is empty, return recent TE IDs (if any)
                if (!query || query.trim() === "") {
                  return Promise.resolve(
                    recentTEIds.length > 0 ? recentTEIds : []
                  );
                }
                Utills.cl(
                  `fetchTEDetallsFromAPI query ${query} offset ${offset}`
                );
                const response = fetchTEDetallsFromAPI(query, offset, "query");
                return response;
              },
              fullWidth: true,
            },
          },
          {
            label: "Buyer TE-ID",
            name: "buyerTEId",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            visible: (values: any) => !!(values?.isBuyerTeCertified === "N" || (getEditTCInfo?.tcMetadataStatus === "Amending" ||
              (getEditTCInfo?.tcId === TE_ID && getEditTCInfo?.isParentStatus)) && initialValues.buyerTEId),
            disabled: (values: any) => {
              // If buyer doesn't have TE-ID (isBuyerTeCertified === "N"), field should be enabled for input
              if (values?.isBuyerTeCertified === "N") {
                return false;
              }
              // For amending status with initial values, keep disabled
              return (getEditTCInfo?.tcMetadataStatus === "Amending" ||
                (getEditTCInfo?.tcId === TE_ID && getEditTCInfo?.isParentStatus)) &&
              initialValues.buyerTEId
                ? true : visible.disableBuyerTEId;
            },
            props: {
              placeholder: "Enter Buyer TE ID",
              fullWidth: true,
            },
          },
          {
            label: "Legal Name of Buyer",
            name: "buyerName",
            type: "search",
            gridSize: { xs: 12, md: 4 },
            required: getTCStandardGOTS ? false : true,
            value: initialValues.buyerName,
            visible: (values: any) => !!(values?.isBuyerTeCertified === "Y"),
            props: {
              placeholder: "Search Buyer Name",
              variant: "outlined",
              displayKey: "account_name",
              onChange: handleBuyerNameValueChange,
              onSearch: (query: string, offset: number) => {
                const response = fetchTEDetallsFromAPI(query, offset, "name");
                return response;
              },
              fullWidth: true,
            },
          },
          {
            label: "Legal Name of Buyer",
            name: "buyerName",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: getTCStandardGOTS ? false : true,
            visible: (values: any) => !!(values?.isBuyerTeCertified === "N"),
            disabled: visible.disableBuyerTEName,
            props: {
              placeholder: "Enter Buyer Name",
              fullWidth: true,
            },
          },
          {
            label: "Buyer Address",
            name: "buyerAddress1",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: getTCStandardGOTS ? false : true,
            value: initialValues.buyerAddress1,
            disabled: (values: any) => {
              if (!disable.buyerAddress1) {
                return false;
              }
              return values?.isBuyerTeCertified !== "N";
            },
            props: {
              placeholder: "Enter Buyer Address",
              fullWidth: true,
            },
          },
          // {
          //   label: "Buyer Address 2",
          //   name: "buyerAddress2",
          //   type: "text",
          //   gridSize: { xs: 12, md: 4 },
          //   required: false,
          //   value: initialValues.buyerAddress2,
          //   disabled: (values: any) => values?.isBuyerTeCertified !== "N",
          //   props: {
          //     placeholder: "Enter Buyer Address 2",
          //     fullWidth: true,
          //   },
          // },
          // {
          //   label: "Buyer Address 3",
          //   name: "buyerAddress3",
          //   type: "text",
          //   gridSize: { xs: 12, md: 4 },
          //   required: false,
          //   value: initialValues.buyerAddress3,
          //   disabled: (values: any) => values?.isBuyerTeCertified !== "N",
          //   props: {
          //     placeholder: "Enter Buyer Address 3",
          //     fullWidth: true,
          //   },
          // },
          {
            label: "Buyer Town",
            name: "buyerTown",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            value: initialValues.buyerTown,
            disabled: (values: any) => {
              if (!disable.buyerTown) {
                return false;
              }
              return values?.isBuyerTeCertified !== "N";
            },
            props: {
              placeholder: "Enter town",
              fullWidth: true,
            },
          },
          {
            label: "Postcode",
            name: "buyerPostcode",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            value: initialValues.buyerPostcode,
            disabled: (values: any) => {
              // If in amending/editing mode and postcode is empty, enable it for user input
              if ((getEditTCInfo?.tcMetadataStatus === "Amending" || 
                (getEditTCInfo?.tcId === TE_ID && getEditTCInfo?.isParentStatus)) && 
                !initialValues.buyerPostcode) {
                return false;
              }
              // Otherwise use existing logic
              if (!disable.buyerPostCode) {
                return false;
              }
              return values?.isBuyerTeCertified !== "N";
            },
            props: {
              placeholder: "Enter postcode",
              fullWidth: true,
            },
          },
          // {
          //   label: "Buyer Country/Area",
          //   name: "buyerCountryOrArea",
          //   type: "text",
          //   gridSize: { xs: 12, md: 4 },
          //   required: true,
          //   value: initialValues.buyerCountryOrArea,
          //   visible: (values: any) => values?.isBuyerTeCertified === 'Y',
          //   disabled: (values: any) => values?.isBuyerTeCertified !== "N",
          //   props: {
          //     placeholder: "Enter Buyer Country/Area",
          //     fullWidth: true,
          //   },
          // },
          // {
          //   label: "Buyer State/Province",
          //   name: "buyerStateOrProvince",
          //   type: "text",
          //   gridSize: { xs: 12, md: 4 },
          //   required: true,
          //   value: initialValues.buyerStateOrProvince,
          //   visible: (values: any) => values.isBuyerTeCertified === 'Y',
          //   disabled: (values: any) => values.isBuyerTeCertified !== "N",
          //   props: {
          //     placeholder: "Enter Buyer State/Province",
          //     fullWidth: true,
          //   },
          // },
          {
            label: "Buyer Country/Area",
            name: "buyerCountryOrArea",
            type: "select",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: getTCStandardGOTS ? false : true,
            value: initialValues.buyerCountryOrArea, // Set initial value here
            disabled: (values: any) => disable.buyerCountry,
            // visible: (values: any) => values?.isBuyerTeCertified == undefined ? false : values.isBuyerTeCertified !== 'Y' ? true : false,
            events: {
              onChange: (newValue: any, updatedValues: any) => {
                let countryCode = JSON.stringify(
                  `[${[newValue].map((item) => `'${item}'`)}]`
                ).replace(/^"|"$/g, "");
                getState(countryCode, true);
              },
            },
            props: {
              enableSearch: true,
              options: countries,
              placeholder: "Select Buyer Country/Area",
              fullWidth: true,
            },
          },
          {
            label: "Buyer State/Province",
            name: "buyerStateOrProvince",
            type: "select",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: getTCStandardGOTS ? false : true,
            value: initialValues.buyerStateOrProvince, // Set initial value here
            disabled: (values: any) => disable.buyerState,
            // visible: (values: any) => values?.isBuyerTeCertified == undefined ? false : values?.isBuyerTeCertified !== 'Y' ? true : false,
            props: {
              options: getBuyerStates,
              enableSearch: true,
              placeholder: "Select Buyer State/Province",
              fullWidth: true,
            },
          },
          {
            label: "Buyer Client No.",
            name: "buyerLicenseNumber",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: getTCStandardGOTS ? true : false,
            value: initialValues.buyerLicenseNumber,
            // disabled: (values: any) => values?.isBuyerTeCertified !== "N",
            props: {
              placeholder: "Enter Buyer Client Number",
              variant: "outlined",
              fullWidth: true,
            },
          },
          {
            label: "Buying On Behalf Of Flag",
            name: "buyingOnBehalfOfFlag",
            type: "radio",
            gridSize: { xs: 12, md: 4 },
            required: (value: any) => {
              if (getTCStandardGOTS) {
                return false;
              }
              return value?.buyingOnBehalfOfFlag == "Y";
            },
            value: initialValues.buyingOnBehalfOfFlag,
            events: {
              onChange: (value: any) => {
                setBuyingOnBehalfOfFlag(value);
                if (value === "N") {
                  // Clear the field when "No" is selected
                  formRef.current.setFieldValue(
                    "buyerCertifiedOrganizationName",
                    ""
                  );
                }
              },
            },
            props: {
              options: [
                { value: "Y", label: "Yes" },
                { value: "N", label: "No" },
              ],
            },
          },
          {
            label: "Buyer Certified Organization Name",
            name: "buyerCertifiedOrganizationName",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: getTCStandardGOTS ? true : (value: any) => value?.buyingOnBehalfOfFlag == 'Y',
            value: initialValues.buyerCertifiedOrganizationName,
            // disabled: (values: any) => values?.buyingOnBehalfOfFlag === "N",
            props: {
              placeholder: getTCStandardGOTS 
                ? "Enter Certified Organization Name" 
                : "Enter Certified Organization Name (Required if Buying On Behalf Of Flag is Yes)",
              variant: "outlined",
              fullWidth: true,
            },
          },
        ],
      },
    ],
    handleSubmit: async (values: any) => {
      try {
        setLoadingState(true);
        const buyerSellerDatas = getCurrentFormValues();
        const payload = mapPayload(
          buyerSellerDatas,
          TE_ID,
          getBuyerStates,
          getSellerStates
        );
        Utills.cl("Buyer Seller Form Submitted:", JSON.stringify(payload), 2);
        const result: any = await executePost(
          TCAppConfig.BUYERS_SELLER_DETAILS,
          payload
        );
        // await transactionCertificateService.saveBuyerSellerDetails(payload)
        if (result.status == 200) {
          notify("Saved Succesfully", "success");
          await onNextTab();
          navigate(`/tc/${formtype}/shipments/${TE_ID}`);
        } else {
          notify("Unable to Save", "error");
          setLoadingState(false);
        }
      } catch (error) {
        setLoadingState(false);
        console.error("Error saving Buyer & Seller Details:", error);
      }
    },
  };

  // Ref to access the Formik instance in FormBuilder
  const formRef = useRef<any>(null);

  const handleSaveNonCertsTrader = async () => {
    if (stepData.nonCertifiedTrader.length === 0) {
      notify("Please add Non-Certified Trader Info", "error");
      return;
    }
    formRef.current.setFieldValue(
      "nonCertifiedTrader",
      stepData.nonCertifiedTrader
    );
    setDialogOpen(false);
    updateField("nonCertifiedTrader", stepData.nonCertifiedTrader);
    // setStepData({
    //   nonCertifiedTrader: nonCertifiedTraderDatas
    // })
  };

  const handleSubmit = () => {
    if (isAdmin) {
      navigate(`/tc/${formtype}/shipments/${TE_ID}`);
      return;
    }
    if (hasSubmitTC) {
      navigate(`/tc/${formtype}/shipments/${TE_ID}`);
    } else if (formRef.current) {
      formRef.current.submitForm(); // Programmatically submit the form
    }
  };
  const handleCancel = () => {
    //ToDo Need to close the Tab
  };
  return (
    <Box>
      {/* Render the FormBuilder component and pass formRef and onSubmit handler */}
      {loading ? (
        <LoaderComponent />
      ) : (
        <>
          <FormBuilder
            formConfig={formConfig}
            onSubmit={formConfig.handleSubmit}
            formRef={formRef}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
            }}
          >
            <NavLink
              to={
                hasSubmitTC
                  ? `/tc/${formtype}/transaction-certificate/${TE_ID}`
                  : `/`
              }
            >
              <StyledButton variant="contained"   sx={{ boxShadow:"none" }}>
                {hasSubmitTC ? "Back" : "Home"}
              </StyledButton>
            </NavLink>
            <StyledButton variant="contained"   sx={{ boxShadow:"none" }} onClick={handleSubmit}>
              {isAdmin ? "Next" : hasSubmitTC ? "Next" : "Save & Next"}
            </StyledButton>
          </Box>
        </>
      )}
      <ModalPopup
        open={dialogOpen}
        onSave={handleSaveNonCertsTrader}
        onClose={() => {
          setDialogOpen(false);
        }}
        disableSave = {isRestrictPopUpSave}
      >
        <NonCertifiedTraderInfo
          nonCertifiedInfoData={stepData.nonCertifiedTrader}
          setNonCertifiedInfoData={(data) =>
            handleDataUpdate("nonCertifiedTrader", data)
          }
        />
      </ModalPopup>
    </Box>
  );
};

export default SellerCertifiedProducts;
